// extracted by mini-css-extract-plugin
export var cardLayout = "_25-1";
export var paginationContainer = "_25-0";